"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _default = function _default(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "shadow rounded bg-card"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-1 text-gray-medium font-light w-40"
  }, children));
};

exports["default"] = _default;
//# sourceMappingURL=LabelMenuLayout.js.map